import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import CountUp from "react-countup";
import { FaAward, FaUsers, FaClock, FaUserTie } from "react-icons/fa";

const stats = [
  { value: 100, suffix: "+", label: "Projects Completed", color: "#f59e0b", icon: <FaAward /> },
  { value: 100, suffix: "+", label: "Happy Clients", color: "#d97706", icon: <FaUsers /> },
  { value: 2, suffix: "yr", label: "In The Industry", color: "#f59e0b", icon: <FaClock /> },
  { value: 30, suffix: "+", label: "Team Members", color: "#10b981", icon: <FaUserTie /> },
];

export default function Stats() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section className="py-16 sm:py-20 relative overflow-hidden">
      <div className="absolute inset-0 gradient-bg opacity-5" />
      <div className="section-divider mb-0" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-14"
        >
          <span className="text-yellow-400 font-semibold text-xs sm:text-sm uppercase tracking-widest">Our Numbers</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mt-3">
            Numbers That <span className="gradient-text">Speak</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass rounded-2xl p-4 sm:p-6 text-center card-hover group"
            >
              <div className="text-2xl sm:text-3xl mb-2 sm:mb-3 group-hover:scale-110 transition-transform inline-block">{stat.icon}</div>
              <div className="text-2xl sm:text-3xl font-black" style={{ color: stat.color }}>
                {inView ? <CountUp end={stat.value} duration={2.5} delay={i * 0.1} /> : 0}
                {stat.suffix}
              </div>
              <div className="text-gray-400 text-xs mt-1 sm:mt-2 leading-tight">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>

      <div className="section-divider mt-16 sm:mt-20" />
    </section>
  );
}
